import { formatarISO } from './Date'

export function supported() {
    return navigator && navigator.mediaDevices && navigator.mediaDevices.getUserMedia
}

export function record() {
    let blob = null
    let shouldStop = false
    let stopped = false
    let startCallback = null
    let start = null
    let permissionDenied = false

    navigator.mediaDevices
        .getUserMedia({ audio: true, video: false })
        .then(function(stream) {
            start = new Date().getTime()
            var options = { mimeType: 'audio/webm' }
            var recordedChunks = []
            var mediaRecorder = new MediaRecorder(stream, options)

            if (startCallback) startCallback(formatarISO(new Date()))

            mediaRecorder.addEventListener('dataavailable', function(e) {
                if (e.data.size > 0) {
                    recordedChunks.push(e.data)
                }

                if (shouldStop == true && stopped == false) {
                    stream.getTracks().forEach(function(track) {
                        track.stop()
                    })

                    mediaRecorder.stop()
                    stopped = true
                    blob = new Blob(recordedChunks)
                }
            })

            mediaRecorder.start(1000)
        })
        .catch(err => {
            permissionDenied = true
        })

    function onStart(callback) {
        startCallback = callback
    }

    function stop(callback) {
        shouldStop = true

        let duraçãoEmSegundos = (new Date().getTime() - start) / 1000

        let checkForBlob = () => {
            if (blob) {
                callback(new File([blob], 'audio.ogg'), duraçãoEmSegundos)
            } else {
                setTimeout(checkForBlob, 100)
            }
        }

        checkForBlob()
    }

    function discard() {
        shouldStop = true
    }

    return {
        onStart,
        stop,
        discard,
        permissionDenied: () => permissionDenied,
    }
}
